import { render } from "./footer.vue?vue&type=template&id=5ae1b70e&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=5ae1b70e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ae1b70e"

export default script